// extracted by mini-css-extract-plugin
export var phone = "_5e-0";
export var phoneDragging = "_5e-1";